var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95703 5.90625V9.23958L11.6237 10.9063",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.40623C2.68674 6.57294 3.54189 4.87257 4.90228 3.62953C6.26267 2.38649 8.03308 1.6878 9.87573 1.66675C11.7184 1.6457 13.5043 2.30378 14.8927 3.51542C16.2811 4.72706 17.1749 6.40746 17.4035 8.236C17.632 10.0645 17.1794 11.9132 16.132 13.4294C15.0845 14.9455 13.5155 16.0229 11.7244 16.4561C9.93326 16.8893 8.04534 16.6479 6.42083 15.7779C4.79632 14.908 3.54893 13.4705 2.91667 11.7396M2.5 15.9062V11.7396H6.66667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsLog);
export default __webpack_public_path__ + "static/media/leadsLog.fe73a675d48a04c829b8d2b2709bfdab.svg";
export { ForwardRef as ReactComponent };